import React from 'react';
import styled from 'styled-components';

import Info from '../components/Info';

import FieldContextFeeder from '../components/FieldContextFeeder';

const InfoField = props => {
  return (
    <Container>
      <Info {...props} />
    </Container>
  );
};

const Container = styled.div`
  max-width: var(--field-width);
`;

export default FieldContextFeeder(InfoField);
